$.fn.navigationAfterContent = function() {
  let self = this

  return function() {
    self.find('button.tabs__item').each(function() {
      $(this).on('click', function(e) {
        e.preventDefault()
        e.stopImmediatePropagation()
        targetTop = self.offset().top - $('.header').outerHeight(false) - 20;
        $('html, body').scrollTo(targetTop, 300, 5, 'easeInOutQuart')
        let tab = $(this).data('tab')
        setTimeout(function() {
          tab.clicked()
        }, 400)
        return false
      })
    });
    return self
  }()
}
